import React, { useEffect } from "react";
import { useLocation } from 'react-router-dom';

import useDfpSlot from './useDfpSlot';

import '../App.scss';
 
function Modal({showModal,hideModal,activeModalData, newPostButton, oldPostButton,disabledNewButton,disabledOldButton}) {
  // const [shareURL] = useState(encodeURIComponent(document.querySelector("[property='og:url']").content));
  ///6674/stuff.shorthand/temaramatanga
  useDfpSlot({
    path: '/6674/stuff.shorthand/temaramatanga',
    id: `div-gpt-ad-8564960-${activeModalData&&activeModalData.id}`,
  });
  
  // console.log('activeModalData: ',activeModalData)
  const location = useLocation();
  useEffect(() => {
    var twitterLib = "https://platform.twitter.com/widgets.js";
    var twitterEmbed = document.querySelector('.twitter-tweet');
    // var flourishLib = "https://public.flourish.studio/resources/embed.js";

    // loadtwitter script initially for loading 
    if (!isLoadedScript(twitterLib)) {
      loadScript(twitterLib);
    } 
    if(isLoadedScript(twitterLib)) {
          // if twitter script is already loaded, and the component is a Twitter embed, ask Twitter library to re-start the Twitter widgets
          if (twitterEmbed && window.twttr) {
             window.twttr.widgets.load();
          }
        }
       
    }
  )

  const isLoadedScript = (lib) => {
    return document.querySelectorAll('[src="' + lib + '"]').length > 0
  }

  const loadScript = (lib) => {
    var script = document.createElement('script');
    script.setAttribute('src', lib);
    script.async = true;
    document.getElementsByTagName('head')[0].appendChild(script);
    return script;
  }

  // share bar in post
  const getWindowDim =  () => {
    let width = Math.min(
        document.body.scrollWidth,
        document.documentElement.scrollWidth,
        document.body.offsetWidth,
        document.documentElement.offsetWidth,
        document.documentElement.clientWidth
      ),
      height = Math.min (
        document.body.scrollHeight,
        document.documentElement.scrollHeight,
        document.body.offsetHeight,
        document.documentElement.offsetHeight,
        document.documentElement.clientHeight,
        window.innerHeight
      );
    return { width: width, height: height};
  }
//  console.log('modal shareURL:', shareURL ,(`/#${location.pathname}`))
  const fbLink = (e) => {
    e.preventDefault();
    let windowWidth = getWindowDim().width,
        left = ( windowWidth - 600) / 2,
        fbURL = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent("https://interactives.stuff.co.nz/2022/the-whole-truth-te-maramatanga/#" + location.pathname)}`
    if(windowWidth > 840) {
      window.open(fbURL, 'facebook', 'width=600, height=450, top=200, left=' + left);
    } else {
      window.open(fbURL);
    }
  }
 
  const twitterLink = (e) => {
    e.preventDefault();
    let windowWidth = getWindowDim().width,
        left = (windowWidth - 600) / 2,
        // twitURL = "https://twitter.com/intent/tweet?url=" + shareURL+`/#${location.pathname}`+ "&text=" + activeModalData.title + "&via=NZSTUFF";
        twitURL = `https://twitter.com/intent/tweet?url=${encodeURIComponent("https://interactives.stuff.co.nz/2022/the-whole-truth-te-maramatanga/#" + location.pathname)}&text=${activeModalData.title}&via=NZSTUFF`;
    if(windowWidth > 840) {
      window.open(twitURL, 'twitter', 'width=600, height=450, top=200, left=' + left);
    } else {
      window.open(twitURL);
    }
  }  

  //  const stringToHTML = function (str) {
  //   var parser = new DOMParser();
  //   var doc = parser.parseFromString(str, 'text/html');
  //   return doc.body;
  //  };
    return (
      <React.Fragment>
        {showModal && (        
          <div className="modalwrapper">
            <div className="modalwrapper--modalbox">
              <span className="modal-button-box--close---top" onClick={hideModal}>&#10005;</span>
              <div className="modalwrapper--modalbox---titlebox">
                <div className="modalwrapper--modalbox---titlebox--label-sharebox">
                  <div className="modalwrapper-container__sharebar">
                  {/* eslint-disable-next-line */}
                  <a onClick={fbLink} className="modalwrapper-container__sharebar--FB"></a>
                  {/* eslint-disable-next-line */}
                  <a onClick={twitterLink} className="modalwrapper-container__sharebar--TW"></a>
                  </div>
                </div>
                <h1 className="modalwrapper--modalbox---titlebox--title">{activeModalData.title}</h1>
                <div className="modalwrapper--modalbox--donation-box">
                <p>Support our fight against misinformation in public health by <a rel="noopener noreferrer"  href="https://interactives.stuff.co.nz/2020/03/support-stuffs-journalism/?utm_source=stuff&utm_medium=widget-post-asset&utm_campaign=supporter-program&utm_content=whole-truth-vaccines" target="_blank">making a contribution here</a>.</p>
                </div>
              </div>
              <div className="modalwrapper--modalbox---picbyline" dangerouslySetInnerHTML={{__html: activeModalData.picByline}}></div>
              <span className="modalwrapper--modalbox---publishdate">Published: {activeModalData.creationDate}</span>
              <div className="modalwrapper--modalbox---content" dangerouslySetInnerHTML={{__html: activeModalData.postBody}}></div>
              <div className="modalwrapper--pijinfobox"><p>Public Interest Journalism funded through NZ On Air</p></div>
              <div className="modalwrapper--projectinfobox">
                <p>This story is part of <span onClick={hideModal}>a fact-checking project</span> on the health and well-being of&#160;Kiwis.</p>
              </div>

              <div className="modal-button-box">
                <span className={disabledNewButton ? "modal-button-box--disabledButton" : "modal-button-box--newpostButton"} onClick={newPostButton}>Newer Posts</span> 
                <span className="modal-button-box--close" onClick={hideModal}>Home</span>
                <span className={disabledOldButton ? "modal-button-box--disabledButton" :"modal-button-box--oldpostButton"} onClick={oldPostButton}>Older Posts</span>
              </div>
                {/* ads start */}
              <div className='ads-wrap-container'>
              <div id={`div-gpt-ad-8564960-${activeModalData.id}`}>
              </div>
              </div>
              {/* ads end */}
            </div>
          </div>
        )}
      </React.Fragment>
    );
}

export default Modal;
